export const Columns = [
    {
        headerName: 'id',
        field: 'id',
        filter: true,
        width: '90'
    },
    {
        headerName: 'customer_code',
        field: 'uuid',
        filter: true,
        width: '320'
    },
    {
        headerName: 'trade_name',
        field: 'name',
        filter: true,
        width: '220'
    },
    {
        headerName: 'corporate_name',
        field: 'corporateName',
        filter: true,
        width: '260'
    },
    {
        // Segmento da empresa; o rótulo vem do i18n pelo valor do enum (coluna "trans").
        headerName: 'category',
        field: 'category',
        type: 'trans',
        width: '150'
    },
    {
        // Pessoa de contato informada no provisionamento e exibida para identificação rápida.
        headerName: 'responsible_name',
        field: 'responsibleName',
        filter: true,
        width: '220'
    },
    {
        headerName: 'cnpj',
        field: 'cnpj',
        filter: true,
        type: 'cnpj',
        width: '170'
    },
    {
        headerName: 'phone',
        field: 'phone',
        filter: true,
        width: '160'
    },
    {
        headerName: 'slug_publico',
        field: 'publicSlug',
        filter: true,
        width: '190'
    },
    {
        headerName: 'trial_days',
        field: 'trialDays',
        filter: true,
        width: '190'
    },
    {
        headerName: 'status',
        field: 'status',
        type: 'trans',
        width: '130'
    }
];
